<div class="min-h-[calc(100vh-4.3rem)] relative">
  <div
    [ngClass]="{
      'pr-0 transition-all duration-300': !sidebarOpen && !isResizing,
      'transition-all duration-200': sidebarOpen && !isResizing,
    }"
    [style.padding-right.px]="sidebarOpen ? sidebarWidth : 0"
  >
    <div class="px-4 py-10 sm:px-6 lg:px-8 lg:py-6 relative h-[calc(100vh-4.3rem)] overflow-hidden @container">
      <p class="text-amazone-green ms-4 me-10 text-end">
        <strong>{{ getItemsTotalCount() }}</strong> SW Part Numbers
      </p>

      <div class="rounded-md shadow-md flex items-center gap-2 px-4 py-2 mb-4">
        <button
          [routerLink]="['/sw-part-number/recycling']"
          class="bg-amazone-gray hover:bg-gray-800 text-white px-4 py-2 rounded-lg h-10 w-10 text-sm items-center flex justify-center cursor-pointer disabled:bg-amazone-gray-light"
          [appEnabledByPolicy]="policy.canReadSoftDeleted"
          appAgentAction
          agent="sw-part-number-overview-recycling"
          businessObject="swPartNumber"
          action="navigate"
        >
          <app-restore-icon></app-restore-icon>
        </button>

        <a
          *appIfPolicySatisfied="policy.canImport"
          [routerLink]="['/import']"
          data-tooltip-target="tooltip-import"
          data-tooltip-placement="right"
          class="text-white bg-amazone-gray hover:bg-gray-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm p-2.5 h-10 w-10 hidden md:inline-block"
        >
          <app-import-create-icon></app-import-create-icon>
        </a>
        <div
          *appIfPolicySatisfied="policy.canImport"
          id="tooltip-import"
          role="tooltip"
          class="absolute z-10 invisible inline-block px-3 py-2 text-sm font-medium text-white transition-opacity duration-300 bg-amber-600 rounded-lg shadow-xs opacity-0 tooltip"
        >
          Create new NW-Numbers and optionally import DTCs from Excel file
          <div class="tooltip-arrow" data-popper-arrow></div>
        </div>

        <div class="place-self-end ms-auto">
          <app-help-popover [iconColor]="'text-amazone-orange'" [paragraphs]="paragraphs"></app-help-popover>
        </div>
      </div>

      <app-sw-part-number-accordion
        [groupedSwPartNumbers]="groupedSwPartNumber"
        [report]="report"
        [selectedSwPartNumberId]="$safeNavigationMigration(selectedItem?.id)"
        (swPartNumberClicked)="onItemClicked($event)"
        (createSnapshotClicked)="handleCreateSnapshot($event)"
        (createNewBranchClicked)="handleCreateBranch($event)"
        (swPartNumberSoftDeleteClicked)="handleSoftDelete($event)"
        (updateSnapshotClicked)="handleUpdateSnapshot($event)"
        (releaseSnapshotClicked)="handleReleaseSnapshot($event)"
        (swPartNumberDownloadClicked)="handleDownload($event)"
        (swPartNumberImportClicked)="handleImport($event)"
        (nwNumberErrorMemoryClicked)="handleNwNumberErrorMemorySelection($event)"
        (swPartNumberDocDownloadClicked)="handleTrDocDownload($event)"
        (resetOnTerminalExportedClicked)="handleResetOnTerminalExportedClicked($event)"
        (resetDocumentationExportedClicked)="handleResetDocumentationExportedClicked($event)"
        (publishEventsClicked)="sendServiceBusEvents($event)"
      ></app-sw-part-number-accordion>
    </div>
  </div>

  @if (sidebarOpen) {
    <div
      class="right-0 fixed overflow-y-auto border-l border-gray-200 min-h-full top-[4rem]"
      [style.width.px]="sidebarWidth"
    >
      <div
        class="absolute left-0 top-0 w-1.5 h-full cursor-col-resize bg-transparent hover:bg-amazone-green hover:opacity-50 transition-colors duration-200"
        (mousedown)="startResize($event)"
      ></div>
      <app-sidebar
        (closeSidebarTriggered)="onClosingSidebar()"
        [detailsViewConfig]="swPartNumberDetailConfiguration"
        [sideBarTitle]="sideBarTitle"
        [sidebarConfiguration]="sidebarConfiguration"
        [editComponentType]="editComponentType.SwPartNumber"
        [editComponentId]="$safeNavigationMigration(selectedItem?.id)"
        [swPartNumber]="selectedItem"
        [detailedLanguageTranslationStatesDocumentation]="aggregatedLanguageTranslationStatesDocumentation"
        [detailedLanguageTranslationStatesTerminal]="aggregatedLanguageTranslationStatesTerminal"
        [nwNumberErrorMemory]="nwNumberErrorMemory"
        (updatedSwPartNumber)="onUpdatedSwPartNumber($event)"
      ></app-sidebar>
    </div>
  }
</div>

<app-decision-modal
  #releaseSnapshotModal
  [header]="'Release snapshot'"
  [details]="['Continue to release the selected snapshot?']"
  [yesNoButtons]="true"
  businessObject="swPartNumber"
  [decisionLevel]="decisionLevel"
  (decision)="handleReleaseSnapshotModelDecision($event)"
></app-decision-modal>
<app-decision-modal
  #updateSnapshotModal
  [header]="'Update snapshot'"
  [details]="['The requested snapshot already exists. Update its content?']"
  [yesNoButtons]="true"
  businessObject="swPartNumber"
  [decisionLevel]="decisionLevel"
  (decision)="handleForceUpdateSnapshotDecision($event)"
></app-decision-modal>
<app-decision-modal
  #createSnapshotModal
  [header]="'Create or update snapshot'"
  [details]="['Continue creating/updating a snapshot?']"
  [yesNoButtons]="true"
  businessObject="swPartNumber"
  [decisionLevel]="decisionLevel"
  (decision)="handleCreateSnapshotDecision($event)"
></app-decision-modal>
<app-decision-modal
  #createNewBranchModal
  [header]="'Prepare a new major release'"
  [details]="['Continue preparing a new major release?']"
  [yesNoButtons]="true"
  businessObject="swPartNumber"
  [decisionLevel]="decisionLevel"
  (decision)="handleNewBranchDecision($event)"
></app-decision-modal>
<app-decision-modal
  #deactivateSwPartNumberModal
  [header]="'Deactivation of'"
  [entityName]="$safeNavigationMigration(swPartNumberToDecide?.displayId)"
  businessObject="swPartNumber"
  [details]="['This SwPartNumber will not be permanently deleted, but only deactivated. Do you want to proceed?']"
  [yesNoButtons]="true"
  [decisionLevel]="decisionLevel"
  (decision)="handleSoftDeleteDecision($event)"
></app-decision-modal>
